import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/ui/sidebar';

export interface NestedMenuItem {
  title: string;
  url?: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  isActive?: boolean;
  items?: NestedMenuItem[];
}

interface SidebarMainProps {
  items: NestedMenuItem[];
  onNavigate?: (path: string) => void;
}

export function SidebarMain({ items, onNavigate }: SidebarMainProps) {
  const { isMobile, setOpenMobile } = useSidebar();

  const handleClick = (url: string, e: React.MouseEvent) => {
    if (onNavigate) {
      e.preventDefault();
      onNavigate(url);
    }
    if (isMobile) setOpenMobile(false);
  };

  return (
    <>
      {items.map((group) => (
        <SidebarGroup key={group.title}>
          <SidebarGroupLabel>{group.title}</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {group.items?.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    asChild
                    isActive={item.isActive}
                    tooltip={item.title}
                    className="text-[0.95rem]"
                  >
                    <a
                      href={item.url || '#'}
                      onClick={(e) => handleClick(item.url || '/', e)}
                    >
                      {item.icon && <item.icon />}
                      <span>{item.title}</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      ))}
    </>
  );
}
